import React from "react";
import { Star, StarHalf, StarOff } from "lucide-react";

export const renderStars = (averageRating) => {
  if (!averageRating) return <span className="text-sm text-gray-500">No ratings yet</span>;

  const fullStars = Math.floor(averageRating);
  const halfStar = averageRating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

  return (
    <div className="flex items-center space-x-1">
      {[...Array(fullStars)].map((_, i) => (
        <Star key={`full-${i}`} className="text-yellow-400" size={18} />
      ))}
      {halfStar && <StarHalf className="text-yellow-400" size={18} />}
      {[...Array(emptyStars)].map((_, i) => (
        <StarOff key={`empty-${i}`} className="text-gray-300" size={18} />
      ))}
      <span className="ml-2 text-sm text-gray-600">({averageRating.toFixed(1)})</span>
    </div>
  );
};